<template>
  <div class="bragingContainer">
    <transition name="fade-transform" mode="out-in">
      <div v-if="!showHighVarianceForm">
        <Created
          ref="createdRef"
          :orderList="nominations"
          :loading="loading"
          :orderIndex="orderIndex"
          :isShowTopinpBar="true"
          :showHighVarianceColumn="true"                  
          :hideCustomCodeColumn="true"          
          @row-click="handleRowClick"
          @openHighVariance="handleOpenHighVariance"
          @updateList="onUpdateList"
          @refreshOnClick="onRefresh"
        />
        <div class="barging-pagination">
          <pagination
            style="background: #f2f7fa"
            :total="total"
            :page.sync="pageParams.pageNum"
            :limit.sync="pageParams.pageSize"
            @pagination="loadHighVarianceNominations()"
          ></pagination>
        </div>
      </div>
      <div v-else>
        <HighVarianceReport
          :nominationId="selectedNominationId"
          @save="showHighVarianceForm = false"
          @cancel="showHighVarianceForm = false"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import Created from "@/view/certificate/BargingNomination/Created.vue";
import HighVarianceReport from "@/view/barging/components/highVarianceReport.vue";
import * as userService from "@/services/user.js";

export default {
  name: "HighVarianceView",
  components: {
    Created,
    HighVarianceReport,
  },
  data() {
    return {
      nominations: [],
      loading: false,
      orderIndex: 0,
      pilotTabs: [],
      showCbnButton: true,
      searchValue: "",
      searchDateType: "",
      selectedNominationId: null,
      showHighVarianceForm: false,
      total: 0,
      pageParams: {
        pageNum: 1,
        pageSize: 20,
      },
    };
  },
  created() {
    this.loadHighVarianceNominations();
  },
  methods: {
    handleOpenHighVariance(id) {
      this.selectedNominationId = id;
      this.showHighVarianceForm = true;
    },
    async loadHighVarianceNominations() {
      this.loading = true;
      try {
        const response = await userService.getHighVarianceNomList({
          searchValue: this.searchValue,
          searchDateType: this.searchDateType,
          startDate: this.startDate,
          endDate: this.endDate,
          pageSize: this.pageParams.pageSize,
          pageNum: this.pageParams.pageNum
        });

        const rows = response.data?.table?.rows;
        this.nominations = Array.isArray(rows) ? rows : [];
        this.total = response.data?.table?.total

      } catch (error) {
        console.error("Failed to load high variance nominations:", error);
        this.nominations = [];
      } finally {
        this.loading = false;
      }
    },
    onUpdateList(searchValue, searchDateType, startDate, endDate) {
      this.searchValue = searchValue;
      this.searchDateType = searchDateType;
      this.startDate = startDate;
      this.endDate = endDate;
      this.loadHighVarianceNominations();
    },
    onRefresh() {
      const ref = this.$refs.createdRef;

      if (ref) {
        const searchValue = ref.Tankinput;
        const searchDateType = ref.Selectvalue;
        const startDate = ref.startDate;
        const endDate = ref.endDate;

        this.onUpdateList(searchValue, searchDateType, startDate, endDate);
      } else {
        console.warn("createdRef not available");
      }
    },
    handleRowClick(row) {
      this.selectedNominationId = row.id;
      this.showHighVarianceForm = true;
    },
  },
};
</script>
